import dataService from "../../api";
import { status } from "@/utils/common";
import { startLoading, stopLoading, serverErrorMessage, showAlert, showNotification, catchHandler } from "@/utils/helpers";

const state = {
    appointments: [],
    appointment: {
        id: null,
        fullName: null,
        bloodType: null,
        birthDate: null,
        gender: null,
        disease: [],
        skinIssues: [],
    },
    doctors: [],
    totalItems: 0,
};
const getters = {
    index: state => (id) => state.appointments.findIndex(i => i.id === id)
};
const mutations = {
    SET_APPOINTMENTS: (state, data) => state.appointments = data,
    SET_TOTAL_ITEMS: (state, r) => (state.totalItems = r),
    SET_APPOINTMENT: (state, viewData) => state.appointment = viewData,
    SET_DOCTORS: (state, viewData) => state.doctors = viewData,
    ADD: (state, addedData) => state.appointments.unshift(addedData),
    UPDATE: (state, { index, updateData }) => state.appointments.splice(index, 1, updateData),
    // DELETE: (state, index) => state.appointments.splice(index, 1),
    approval: (state, index) => state.appointments[index].status = status.active,
    DELETE: (state, index) => state.appointments[index].status = status.rejected,

};
const actions = {
    async getAll({ commit }, params) {
        startLoading()
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            const response = await dataService.appointments.getAll(paramsString);

            stopLoading()
            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit('SET_APPOINTMENTS', response.data.appointments);
            commit('SET_TOTAL_ITEMS', response.data.totalItems);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getDetails({ commit }, id) {
        startLoading()
        try {
            commit('SET_APPOINTMENT', {});
            const response = await dataService.appointments.getDetails(id);
            stopLoading()
            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit('SET_APPOINTMENT', response.data.appointment);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async approval({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.appointments.approval(id);
            stopLoading()
            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            showNotification(response.data.message);
            const index = getters.index(id);
            commit("approval", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
     async approvalReview({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.appointments.approvalReview(id);
            stopLoading()
            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            showNotification(response.data.message);
            const index = getters.index(id);
            commit("approval", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getForEdit(_, id) {
        startLoading()
        try {
            const response = await dataService.appointments.getForEdit(id);
            stopLoading()
            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            return Promise.resolve(response.data.appointment);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },



    async add({ commit }, payload) {
        try {
            startLoading()
            const response = await dataService.appointments.add(payload);
            stopLoading()
            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            showNotification(response.data.message);
            commit('ADD', response.data.appointment);
        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);

        }
    },
    async edit({ commit, getters }, { id, payload }) {
        startLoading()
        try {
            const response = await dataService.appointments.edit(id, payload);
            stopLoading();
            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            showNotification(response.data.message);

            const index = getters.index(id);
            commit('UPDATE', { index: index, updateData: response.data.appointment });

        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);

        }
    },
    async delete({ commit, getters }, id) {
        startLoading()
        try {
            const response = await dataService.appointments.delete(id);
            stopLoading();
            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            showNotification(response.data.message);

            const index = getters.index(id);
            commit('DELETE', index);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    // ------------------------------------------------------------ //
    async search(_, params) {
        startLoading()
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            const response = await dataService.appointments.search(paramsString);
            stopLoading()
            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            return Promise.resolve(response.data);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getDoctors({ commit, state }) {
        if (state.doctors.length == 0) {

            try {
                const response = await dataService.appointments.getDoctors();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                commit('SET_DOCTORS', response.data.doctors);
            } catch (error) {
                catchHandler(error);
            }
        }
    },
    async getDoctorAppointments(_, id) {
        startLoading()
        try {
            const response = await dataService.appointments.getDoctorAppointments(id);

            stopLoading()
            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            return Promise.resolve(response.data.doctorAppointments);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async checkAppointment(_, params) {
        startLoading()
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            const response = await dataService.appointments.checkAppointment(paramsString);

            stopLoading()
            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            return Promise.resolve(response.data);

        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);

        }
    }, 
     async checkFollowup(_, params) {
        startLoading()
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            const response = await dataService.appointments.checkFollowup(paramsString);

            stopLoading()
            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            return Promise.resolve(response.data);

        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);

        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
